import LogoTiles from '../components/LogoTiles';
import StoreButton from '../components/StoreButton';

export default function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-content">
        <div className="hero-left">
          <div className="hero-app-icon">
            <img src="/assets/logo.png" alt="Lexira app icon" />
          </div>
          <LogoTiles size="hero" />
          <div className="hero-tagline">WORD · PUZZLE</div>
          <p className="hero-desc">
            Swipe letters, build words, earn stars. 100 hand-crafted levels,
            daily challenges, and expressive mascots to cheer you on.
            Available on iOS &amp; Android — free to play.
          </p>
          <div className="hero-btns">
            <StoreButton store="apple" />
            <StoreButton store="google" />
          </div>
        </div>
        <div className="hero-mascot">
          <img src="/assets/mascot/mascot-happy.svg" alt="Lexi the mascot" />
        </div>
      </div>
      <div className="hero-scroll-hint">
        <span>SCROLL</span>
        <span className="scroll-arrow">↓</span>
      </div>
    </section>
  );
}
